import { configureStore } from "@reduxjs/toolkit";
import applicationsReducer from "./applicationsSlice";

// Load state from localStorage
const loadState = () => {
  try {
    const serializedState = localStorage.getItem("job_portal_applications");
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

// Save state to localStorage
const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem("job_portal_applications", serializedState);
  } catch {
    // Ignore write errors
  }
};

const persistedState = loadState();

const store = configureStore({
  reducer: {
    applications: applicationsReducer,
  },
  preloadedState: persistedState,
});

store.subscribe(() => {
  saveState({
    applications: store.getState().applications,
  });
});

export default store;
